export enum Status {
	OK = 0,
  NotMapped,
	AwaitingApproval
}
